import React, { useState, useEffect } from "react";
import { Button, Pagination } from "rsuite";
import { numberFormatter } from "../../utils";
import PlusRoundIcon from "@rsuite/icons/PlusRound";
import MinusRoundIcon from "@rsuite/icons/MinusRound";

const RecommendedItemsTable = (props: any) => {
  const [limit, setLimit] = React.useState(10);
  const [quantity, setQuantity] = React.useState(null);
  const [price, setPrice] = React.useState(null);

  useEffect(() => {
    console.log(props.data.list);
  }, [props]);

  return (
    <>
      <div className="h-[29vh] overflow-auto mt-[1vh]">
        <table className="supplierTable">
          <thead>
            <tr>
              <th>Item ID</th>
              <th>Description</th>
              <th>Recommended Quantity (eaches/year)</th>
              <th>Price ($/each)</th>
              <th>Margin ($/each)</th>
              <th>Opportunity Revenue($)</th>
              <th>Opportunity Margin($)</th>
              <th>Include in this?</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(props.data) &&
              props?.data?.map((d: any, index: any) => {
                return (
                  <React.Fragment key={d.customer + "_" + index}>
                    <tr key={d.customer} onClick={() => {}}>
                      <td>{d.customer}</td>
                      <td>{d.customer_desc}</td>

                      <td>
                        <input
                          type="text"
                          maxLength={8}
                          minLength={8}
                          className="material-number-search"
                          onInput={(e: any) => {
                            return (e.target.value = e.target.value.replace(
                              /[^\d]/g,
                              ""
                            ));
                          }}
                          value={
                            quantity ? quantity : numberFormatter(d.quantity, 0)
                          }
                          onChange={(e: any) => {
                            setQuantity(e.target.value);
                          }}
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          maxLength={8}
                          minLength={8}
                          className="material-number-search"
                          onInput={(e: any) => {
                            return (e.target.value = e.target.value.replace(
                              /[^\d]/g,
                              ""
                            ));
                          }}
                          value={price ? price : numberFormatter(d.netSales, 0)}
                          onChange={(e: any) => {
                            setPrice(e.target.value);
                          }}
                        />
                      </td>

                      <td>{numberFormatter(d.netMargin, 0, "$")}</td>
                      <td>{numberFormatter(d.currentRevenue, 0, "$")}</td>
                      <td>{numberFormatter(d.marginOpportunity, 0, "$")}</td>
                      <td>
                        <input
                          type="checkbox"
                          onChange={() => {}}
                          //   defaultChecked={
                          //     d.include === 1 || acceptedData[d.l4] ? true : false
                          //   }
                        />
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}
          </tbody>
        </table>
      </div>
      <div className="flex gap-x-[2vh] pt-[1vh] justify-end">
        <button className=" bg-green-700 px-2 py-1 rounded-md">Submit</button>
        <button className=" bg-green-700 px-2 py-1 rounded-md">Save</button>
      </div>
    </>
  );
};
export default RecommendedItemsTable;
